// extracted by mini-css-extract-plugin
module.exports = {"section":"CurrentBid_section__2oRi6"};